<template>
  <div id="app" class="mb-3">
    <div class="card mb-3 rounded">
      <div class="card-header text-center bg-white">
        <div class="row">
          <div class="col-md-12">
            <b-button size="sm" variant="warning" @click="append('【')"
              >【</b-button
            >
            <b-button size="sm" variant="warning" @click="append('】')"
              >】</b-button
            >
            <b-button size="sm" variant="danger" @click="append('〖')"
              >〖</b-button
            >
            <b-button size="sm" variant="danger" @click="append('〗')"
              >〗</b-button
            >
            <b-button size="sm" variant="success" @click="append('〘')"
              >〘</b-button
            >
            <b-button size="sm" variant="success" @click="append('〙')"
              >〙</b-button
            >
            <b-button size="sm" variant="primary" @click="append('﹝')"
              >﹝</b-button
            >
            <b-button size="sm" variant="primary" @click="append('﹞')"
              >﹞</b-button
            >
          </div>
        </div>
        <div class="row mt-1">
          <div class="col-md-12">
            <b-button size="sm" variant="warning" @click="append('★')"
              >★</b-button
            >
            <b-button size="sm" variant="warning" @click="append('❁')">
              ❁</b-button
            >
            <b-button size="sm" variant="danger" @click="append('🌈')"
              >🌈</b-button
            >
            <b-button size="sm" variant="danger" @click="append('♥')"
              >♥</b-button
            >
            <b-button size="sm" variant="success" @click="append('◢')"
              >◢</b-button
            >
            <b-button size="sm" variant="success" @click="append('◣')"
              >◣</b-button
            >
            <b-button size="sm" variant="primary" @click="append('⇦')"
              >⇦</b-button
            >
            <b-button size="sm" variant="primary" @click="append('⇨')"
              >⇨</b-button
            >
          </div>
        </div>
        <div class="row mt-1">
          <div class="col-md-12">
            <b-button size="sm" variant="warning" @click="append('❄')"
              >❄</b-button
            >
            <b-button size="sm" variant="warning" @click="append('✌')"
              >✌</b-button
            >
            <b-button size="sm" variant="danger" @click="append('✞')"
              >✞</b-button
            >
            <b-button size="sm" variant="danger" @click="append('☯')"
              >☯</b-button
            >
            <b-button size="sm" variant="primary" @click="append('🌴')"
              >🌴</b-button
            >
            <b-button size="sm" variant="primary" @click="append('✈')"
              >✈</b-button
            >
          </div>
        </div>
      </div>
      <div class="pl-3 pr-3 pt-2 pb-2 blue-1">
        <b-form-input
          id="input-live"
          v-model="text"
          v-focus
          class="estilo"
          placeholder="Escribe aquí la frase..."
          trim
          @click="fistClear()"
        ></b-form-input>
      </div>
      <div class="card-footer" v-if="this.variations.length > 0">
        <a class="btn btn-danger text-white font-weight-bold" @click="borrar()"
          >Empezar de nuevo</a
        >
      </div>
    </div>
    <div id="result" class="row mt-3">
      <div class="col">
        <b-list-group>
          <b-list-group-item
            v-for="(fancytext, index) in variations"
            v-bind:key="index"
            class="text-left"
          >
            {{ fancytext }}
            <b-button
              variant="success"
              size="sm"
              class="float-right font-weight-bold"
              pill
              @click="copy(fancytext)"
              >Copiar</b-button
            >
          </b-list-group-item>
          <b-list-group-item v-if="this.variations.length > 0">
            <b-button
              @click="generarmas()"
              variant="success"
              class="font-weight-bold"
              >Generar Más</b-button
            >
            <a
              class="btn btn-danger text-white font-weight-bold"
              @click="borrar()"
              >Empezar de nuevo</a
            >
          </b-list-group-item>
        </b-list-group>
      </div>
    </div>
    <b-toast
      toaster="b-toaster-bottom-center"
      id="my-toast"
      variant="success"
      solid
    >
      <template v-slot:toast-title>
        <div class="d-flex flex-grow-1 align-items-baseline">
          <b-img
            blank
            blank-color="#ff5555"
            class="mr-2"
            width="12"
            height="12"
          ></b-img>
          <strong class="mr-auto">Copiado!</strong>
        </div>
      </template>
      Se ha copiado, ya pegar la frase donde quieras...
    </b-toast>
  </div>
</template>

<script>
import * as unicode from "./utils/unicode";

export default {
  name: "App",
  components: {},
  created: function () {
    /*this.$bvToast.toast(
      "En cumplimiento con Ley 34/2002, de servicios de la sociedad de la información te recordamos que al navegar por este sitio estás aceptando el uso de cookies.",
      {
        title: "Politica de Cookies",
        toaster: "b-toaster-bottom-center",
        solid: true,
        variant: "danger",
        autoHideDelay: 1000,
        appendToast: false,
      }
    );*/
  },
  mounted() {
    // this.typeInitial();
  },
  methods: {
    fistClear: function () {
      if (this.text == "Escribe aquí tu frase") {
        this.text = "";
      }
    },
    fancy: function () {
      return unicode.forward(this.text);
    },
    copy: function (value) {
      this.$clipboard(value);
      this.$bvToast.show("my-toast");
    },
    generarmas: function () {
      this.variations.push.apply(this.variations, unicode.moreFancy(this.text));
    },
    borrar: function () {
      this.text = "";
      this.variations = [];
    },
    append: function (value) {
      this.text += value;
    },
    typeInitial: function () {
      let txt = "Escribe aquí tu frase";
      let speed = 50;
      if (this.inc < txt.length) {
        this.text += txt.charAt(this.inc);

        this.inc++;
        setTimeout(this.typeInitial, 100);
      }
    },
  },
  watch: {
    text: function (val) {
      if (val === "") {
        this.variations = [];
      } else {
        this.variations = unicode.getVaritations(val);
      }
    },
  },
  data: function () {
    return {
      text: "",
      variations: [],
      inc: 0,
    };
  },
};
</script>

<style scoped>
h1 {
  font-size: 1.4rem;
}

.blue-1 {
  background-color: #ebf8ff;
}

.estilo {
  border-radius: 25px;
  border: 2px solid #bee3f8;
  padding: 20px;
  height: 15px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue